import { ShaderDefine } from "../../RenderEngine/RenderShader/ShaderDefine";

export class SkinnedMeshSprite3DShaderDeclaration {
	/**精灵级着色器宏定义,蒙皮动画。*/
	static SHADERDEFINE_BONE: ShaderDefine;
	static SHADERDEFINE_SIMPLEBONE:ShaderDefine;
}